// extracted by mini-css-extract-plugin
module.exports = {"home":"_2ndbc","instagramFeed":"_2ptmP","banner":"e86G4"};